import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface SelectedLesson {
  sectionIndex: number;
  lessonIndex: number;
  itemIndex: number;
  lesson: any;
}

interface CourseLessonState {
  courseData: any | null;
  selectedLesson: SelectedLesson | null;
}

interface RootState {
  courseLesson: CourseLessonState | null;
}

const initialState: RootState = {
  courseLesson: JSON.parse(localStorage.getItem("course-lesson") || "null") || {
    courseData: null,
    selectedLesson: null
  }
};

export const courseLessonSlice = createSlice({
  name: "courseLesson",
  initialState,
  reducers: {
    setCourseLesson: (state, action: PayloadAction<CourseLessonState>) => {
      state.courseLesson = action.payload;
      localStorage.setItem("course-lesson", JSON.stringify(action.payload));
    },
    clearCourseLesson: (state) => {
      state.courseLesson = {
        courseData: null,
        selectedLesson: null
      };
      localStorage.removeItem("course-lesson");
    }
  }
});

export const { setCourseLesson, clearCourseLesson } = courseLessonSlice.actions;
export default courseLessonSlice.reducer;
